import { Modal } from "@mui/material";
import React, { useState } from "react";
import CommonDateSelectionForm from "./CommonDateSelectionForm";
import { toast } from "react-toastify";
import axios from "axios";
import { path } from "../../path";
import { Close } from "@mui/icons-material";
import { useSelector } from "react-redux";

const ActivityReportModal = ({ open, toggle }) => {
  const [loading, setLoading] = useState(false);
  const { token } = useSelector((state) => state.AuthReducer);

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    try {
      setLoading(true);

      const fromDate = event.target["fromDate"]?.value;
      const toDate = event.target["toDate"]?.value;

      if (!fromDate || !toDate) {
        toast.error("Date cannot be empty!");
        return;
      }

      if (new Date(fromDate) > new Date(toDate)) {
        toast.error("From date cannot be greater than to date!");
        return;
      }

      if (new Date(toDate) > Date.now()) {
        toast.error("To date cannot be in the future!");
        return;
      }

      const config = {
        host: `${path}`,
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": `${path}`,
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      };
      const res = await axios.get(
        `${path}/reports/dauActivityReport?fromDate=${fromDate}&toDate=${toDate}`, config
      );

      if (res.status === 200 || res.status === 304) {
        // Extract filename from Content-Disposition header
        const disposition = res.headers['content-disposition'];
        const filename = disposition?.match(/filename="?([^"]+)"?/)?.[1] ?? 'report.csv';

        const url = URL.createObjectURL(res.data);
        const a    = document.createElement('a');
        a.href     = url;
        a.download = filename;
        a.click();

        URL.revokeObjectURL(url);
        toast.success("Report generated successfully!");
        toggle();
      } else {
        toast.error(res.data.message || "Error generating report!");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Error generating report!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={toggle}
      className="flex items-center justify-center">
      <div className="bg-white p-5 rounded w-[650px] max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex justify-between mb-4">
          <h2 className="text-xl font-bold">Activity Report</h2>
          <Close className="cursor-pointer" onClick={toggle} />
        </div>

        <CommonDateSelectionForm
          btnText="Generate Report"
          onSubmitHandler={onSubmitHandler}
          loading={loading}
        />
      </div>
    </Modal>
  );
};

export default ActivityReportModal;
